import TableService from "../services/tableService";
import { useAsync } from "./useAsync";
import React, { useState, useEffect } from "react";

const useLocalData = (dataFn,
  searchParams,
  withPagination = false,
  id = undefined,
  config = undefined,
  hiddenColumns = [],
  columnsOrder = [],
  ...extraTabsConfig) => {



  const [localData, setLocalData] = useState();
  const [dataCount, setDataCount] = useState();

  const getData = useAsync(() => {
    if (dataFn) {
      if (id) {
        return dataFn(id, searchParams)
      }
      return dataFn(searchParams)
    }
    return Promise.resolve()
  }, [searchParams, id])


  useEffect(() => {
    if (getData.loading) {
      return;
    }
    if (withPagination && getData.value) {
      setLocalData(getData.value.results)
      setDataCount(getData.value.count)
    } else if (getData.value) {
      setLocalData(getData.value)
    }
  }, [getData.loading, withPagination]);



  const data = React.useMemo(
    () => {
      if (config) {
        return TableService.getPreparedDataForCollapsibleTable(
          config,
          localData ?? [],
          hiddenColumns ?? [],
          columnsOrder ??[],
          ...extraTabsConfig
        );
      }
      return undefined
    },
    [config,
      localData,
      hiddenColumns,
      columnsOrder,
      ...extraTabsConfig]
  );


  return {
    data: localData,
    setLocalData: setLocalData,
    dataCount: dataCount,
    dataLoading: getData.loading,
    dataRefetch: getData.refetch,
    tableData: data
  };
};

export default useLocalData;
